import { array, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import agentRequestListAction from './agentRequestList.action.json'

const agentRequestListDefinition = defineAction({
  ...agentRequestListAction,
  userActivityLog: true,
  operation: 'read' as const,
  input: object({
    agentCpf: string(),
  }),
  output: object({
    requests: array(
      object({
        entrepreneurCpf: string(),
        status: string(),
        latitude: number(),
        longitude: number(),
        accuracy: number().isOptional(),
        street: string().isOptional(),
        approximateNumber: string().isOptional(),
        neighborhood: string().isOptional(),
        city: string().isOptional(),
        cityIbge: number().isOptional(),
        stateAbbreviation: string().isOptional(),
        lastGeolocationUpdate: dateTime().isOptional(),
        geodesicDistanceMeters: number().isOptional(),
        drivingDistanceMeters: number().isOptional(),
        lastStatusUpdate: dateTime().isOptional(),

        offerStatus: enumerated({
          pending: 'pending',
          accepted: 'accepted',
        }).isOptional(),
        offeredAt: dateTime().isOptional(),
        serviceReason: string().isOptional(),
        address: object({
          displayAddress: string().isOptional(),
          postalCode: string().isOptional(),
          stateAbbreviation: string().isOptional(),
          city: string().isOptional(),
          cityId: number().isOptional(),
          neighborhood: string().isOptional(),
          street: string().isOptional(),
          number: string().isOptional(),
          complement: string().isOptional(),
          reference: string().isOptional(),
        }).isOptional(),
        companyName: string().isOptional(),
        contactPhone: string().isOptional(),
        metricsCalculatedAt: dateTime().isOptional(),
        estimatedDurationSeconds: number().isOptional(),
        route: object({
          status: enumerated({
            calculated: 'calculated',
            unavailable: 'unavailable',
          }).isOptional(),
          distanceMeters: number().isOptional(),
          durationSeconds: number().isOptional(),
          geometry: object({
            type: enumerated({
              lineString: 'LineString',
            }),
            coordinates: array(array(number())),
          }).isOptional(),
          calculatedAt: dateTime().isOptional(),
          agentLocationCapturedAt: dateTime().isOptional(),
        }).isOptional(),

        legalEntityCnpj: string().isOptional(),
        corporateName: string().isOptional(),
        tradeName: string().isOptional(),
        economicActivity: string().isOptional(),
        sizeAbbreviature: string().isOptional(),
      }),
    ),
  }),
})

export default agentRequestListDefinition
